export enum TemplateType {
    REGULAR = 'regular',
    EFORM = 'eform',
    TEMPLATEDOCUMENT = 'template_document',
    PDF = 'pdf',
    EXCEL = 'excel',
    WORD = 'word'
}

export const DocumentTypeEnum = TemplateType;
